import React from 'react'
import { Alert } from 'antd'
import { useSelector } from 'react-redux'

const MIGRATION_DATE = new Date('2026-06-01')

export function isDeprecatedApiType(apiType) {
	if (!apiType) return false
	if (apiType === 'legacy_api') return true
	if (apiType === 'new_api' && new Date() >= MIGRATION_DATE) return true
	return false
}

function buildMessage(smallDeprecated, ltlDeprecated) {
	// LTL combined message commented — FedEx Freight MFA migration not active
	// if (smallDeprecated && ltlDeprecated) {
	// 	return 'FedEx and FedEx Freight have deprecated the APIs you are using. You must reconnect to FedEx and FedEx Freight using its new REST MFA API (eff. June 1, 2026). Edit the FedEx and FedEx Freight Connection Settings, select the new API, and complete the steps to re-establish the connection.'
	// }
	if (smallDeprecated) {
		return 'FedEx has deprecated the API you are using. You must reconnect to FedEx using its new REST MFA API (eff. June 1, 2026). Edit the FedEx Connection Settings, select the new API, and complete the steps to re-establish the connection.'
	}
	// LTL-only message commented — FedEx Freight MFA migration not active
	// if (ltlDeprecated) {
	// 	return 'FedEx Freight has deprecated the API you are using. You must reconnect to FedEx Freight using its new REST MFA API (eff. June 1, 2026). Edit the FedEx Freight Connection Settings, select the new API, and complete the steps to re-establish the connection.'
	// }
	return null
}

// Global banner — reads from Redux, shows when any active FedEx carrier is on a deprecated API.
export default function FedexMigrationBanner({ style }) {
	const { installedCarriers, FedexSmallApiType, FedexLTLApiType } = useSelector(state => state)

	const activeCarriers = (installedCarriers || []).filter(c => c.is_enabled === 1 || c.is_enabled === '1')
	const hasSmall = activeCarriers.some(c => c.slug === 'fedex-small')
	const hasLtl   = activeCarriers.some(c => c.slug === 'fedex-ltl')

	const smallDeprecated = hasSmall && isDeprecatedApiType(FedexSmallApiType)
	const ltlDeprecated   = hasLtl   && FedexLTLApiType === 'legacy_api' // only legacy_api, REST API not flagged for LTL

	const message = buildMessage(smallDeprecated, ltlDeprecated)
	if (!message) return null

	return (
		<Alert
			type='warning'
			message={message}
			showIcon
			style={{ marginBottom: 16, ...style }}
		/>
	)
}

// Per-carrier banner shown on the connection settings page.
export function FedexConnectionSettingsBanner({ apiType, customMessage }) {
	if (!isDeprecatedApiType(apiType)) return null

	const isLegacy = apiType === 'legacy_api'
	const message = customMessage ?? (isLegacy
		? 'FedEx has deprecated the API you are using. You must reconnect to FedEx using its new REST MFA API (eff. June 1, 2026). Edit the FedEx Connection Settings, select the new API, and complete the steps to re-establish the connection.'
		: 'You are using the REST API (pre June 1, 2026) which was deprecated by FedEx on June 1, 2026. Select "REST MFA API (eff. June 1, 2026)" and complete the steps to re-establish the connection.')

	return (
		<Alert
			type='warning'
			message={message}
			showIcon
			style={{ marginBottom: 20 }}
		/>
	)
}
